<template>
  <div class="calendar">
    <v-calendar
      :attributes="attrs"
      :minDate="minDate"
      :maxDate="maxDate"
      weeksTransition="none"
      titleTransition="none"
    ></v-calendar>
    <ul class="caption">
      <li v-for="(item, i) in content.caption" :key="i">
        <div
          :style="{
            backgroundColor: item.color,
            border: item.color
          }"
          class="color"
        ></div>
        <p v-html="item.text"></p>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dates: null,
      attrs: []
    };
  },
  computed: {
    minDate() {
      const min = new Date();
      min.setFullYear(min.getFullYear() - 1)
      return min
    },
    maxDate() {
      const max = new Date();
      max.setFullYear(max.getFullYear() + 1)
      return max
    },
    orderedAttrs() {
      const temp = JSON.parse(JSON.stringify(this.attrs));
      return temp.sort((a, b) => {
        return a.visualOrder < b.visualOrder ? -1 : 1;
      });
    },
  },
  methods: {
    csvJSON(csv) {
      let delimiter = ","
      if(csv.includes(";")) {
        delimiter = ";"
      }
      var lines = csv.split("\n");
      var result = [];
      var headers = lines[0].split(delimiter);
      for (var i = 1; i < lines.length; i++) {
        var obj = {};
        var currentline = lines[i].split(delimiter);
        for (var j = 0; j < headers.length; j++) {
          let h = headers[j].trim();
          obj[h] = currentline[j];
        }
        result.push(obj);
      }

      return result; //JavaScript object
    }
  },
 mounted() {
    
    this.attrs = this.content.caption.map(item => {
      return {
        title: item.text,
        visualOrder: parseInt(item.order),
        highlight: {
          backgroundColor: item.color
        },
        dates: []
      };
    });
    axios.get(this.content.file).then(res => {
      let dates = this.csvJSON(res.data);
      for (let i = 0; i < dates.length; i++) {
        let date = dates[i];
        if (this.attrs[parseInt(date.ouverture)]) {
          this.attrs[parseInt(date.ouverture)].dates.push(date.day);
        }
      }
    });
  }
};
</script>

<style lang="scss">
.calendar {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
  width: $content-width;
  max-width: $max-width;
  margin: 3em auto;
}
.caption {
  display: block;
  > li {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .color {
      width: 30px;
      height: 30px;
      margin-right: 10px;
      border-radius: 50%;
    }
  }
}

.calendar {
  .c-pane-container {
    border: none !important;
    border-radius: 10px;
    overflow: hidden;
    .c-header {
      padding: 20px 10px;
      background-color: $primary;
      .c-title {
        font-family: "Luckiest Guy", cursive;
        color: #fff;
      }
    }
    .c-weekdays,
    .c-weeks {
      padding: 10px 30px;
    }
    .c-week {
      padding: 4px 0;
    }
    .c-day-content {
      color: #fff;
      font-weight: bold;
    }
  }
}
@media screen and (max-width: 700px) {
  .calendar {
    display: block;
    .c-pane-container {
      width: 100%;
    }
    .caption {
      margin: 20px 5px;
    }
  }
}
</style>
